import styled from 'styled-components';

export default styled.div`
  background-color: white;
  border-left: 10px solid ${(props) => props.theme.colors.grey};
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25));
  display: flex;
  align-items: center;
  position: relative;

  &:not(:first-child) {
    margin-top: 12px;
  }

  &.goal {
    border-left-color: ${(props) => props.theme.colors.primary};
  }

  &.yellowCard {
    border-left-color: ${(props) => props.theme.colors.secondary};
  }

  &.redCard {
    border-left-color: ${(props) => props.theme.colors.error};
  }

  &.active {
    background-color: ${(props) => props.theme.colors.secondary};
  }

  .index {
    margin-left: 8px;
    width: 18px;
    &.green {
      color: #30826a;
    }
    &.red {
      color: #d50000;
    }
  }

  .line {
    position: absolute;
    height: 100%;
    left: 71px;
    top: 0;
    width: 1px;
    letter-spacing: 10px;
    background-image: linear-gradient(black 33%, rgba(255, 255, 255, 0) 0%);
    background-position: right;
    background-size: 1px 10px;
    background-repeat: repeat-y;
  }

  .icon {
    position: absolute;
    width: 28px;
    height: 28px;
    left: 57px;
  }

  .event-actions {
    position: absolute;
    bottom: 10px;
    right: 10px;
    display: flex;
    justify-content: flex-end;

    img {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }

    .delete {
      margin-left: 10px;
    }
  }

  .event-content {
    padding: 15px;
    padding-bottom: 25px;
    margin-left: 57px;
    min-height: 80px;
    box-sizing: border-box;
    display: grid;
    grid-template-rows: auto 1fr;

    .comment {
      font-size: 12px;
      line-height: 14px;
      display: flex;
      align-items: center;
    }
    .commentWithHeader {
      padding-top: 2px;
    }
  }

  .request-status-container {
    position: absolute;
    top: 10px;
    right: 10px;

    .error-container {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  .event-text-container {
    padding-right: 20px;
  }
`;
